var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReady),expression:"isReady"}]},[_c('Header',{attrs:{"isLink":false}}),_vm._v(" "),_c(_vm.comp,{ref:"comp",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }